import { render, staticRenderFns } from "./Staging-Delivered-Correction-View.vue?vue&type=template&id=68b0f584&scoped=true&"
import script from "./Staging-Delivered-Correction-View.vue?vue&type=script&lang=js&"
export * from "./Staging-Delivered-Correction-View.vue?vue&type=script&lang=js&"
import style0 from "./Staging-Delivered-Correction-View.vue?vue&type=style&index=0&id=68b0f584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0f584",
  null
  
)

export default component.exports